import { WalletTypesConfig } from "@cede/types";
import { WALLET_TYPES_COMMON_CONFIG } from "./walletTypes.common.config";

export const WALLET_TYPES_TEST_CONFIG: WalletTypesConfig = {
  ...WALLET_TYPES_COMMON_CONFIG,
};
